import React from 'react';


const InputWithExtra = (props) => {

	return (  
  

      
        <div className="input-group">  
          <span className="input-group-addon">
            <i className={props.icon} aria-hidden="true"></i>
          </span>
          <input
            className="form-control1"
            id={props.name}
            name={props.name}
            type={props.inputType}
            value={props.value}
            onChange={props.handleChange}
            placeholder={props.placeholder} 
            {...props} />
         </div>   
        
     
)
}

export default InputWithExtra;